import { AddBankAccountComponent } from './../add-bank-account/add-bank-account.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { AddInstitutionComponent } from '../add-institution/add-institution.component';
import { AddExchangeComponent } from '../add-exchange/add-exchange.component';

import { of } from 'rxjs';
import { NgWizardConfig, NgWizardService, StepChangedArgs, StepValidationArgs, STEP_STATE, THEME } from 'ng-wizard3';
import { SessionService } from '../../services/session/session.service';
import { AddBankComponent } from '../add-bank/add-bank.component';
import { CustomerCreationComponent, CustomerCreationModalComponent } from '../customer-creation/customer-creation.component';
import { ToastrService } from 'ngx-toastr';
import { CreateMasterAccountComponent } from '../create-master-account/create-master-account.component';
import { SummaryCreateInstitutionComponent } from '../summary-create-institution/summary-create-institution.component';
import { TradingLimitsInstitutionComponent } from '../trading-limits-institution/trading-limits-institution.component';

@Component({
    selector: 'app-add-institution-main',
    templateUrl: './add-institution-main.component.html',
    styleUrls: ['./add-institution-main.component.css'],
    standalone: false
})
export class AddInstitutionMainComponent implements OnInit {
  role: any;
  canExitStep: boolean = false;
  @ViewChild(AddInstitutionComponent) AddInstitutionComponent!: AddInstitutionComponent;
  @ViewChild(AddExchangeComponent) AddExchangeComponent!: AddExchangeComponent;
  @ViewChild(AddBankComponent) AddBankComponent!: AddBankComponent;
  @ViewChild(AddBankAccountComponent) AddBankAccountComponent!: AddBankAccountComponent;
  @ViewChild(CustomerCreationComponent) customerCreationComponent!: CustomerCreationComponent;
  @ViewChild(CreateMasterAccountComponent) CreateMasterAccountComponent!: CreateMasterAccountComponent;
  @ViewChild(SummaryCreateInstitutionComponent) SummaryCreateInstitutionComponent!: SummaryCreateInstitutionComponent;
  @ViewChild(TradingLimitsInstitutionComponent) TradingLimitsInstitutionComponent!: TradingLimitsInstitutionComponent;
  instCode: any = "";
  selectedStep: number = 0;
  isFormValid: any;




  constructor(
    private ngWizardService: NgWizardService,
    private addInstitutionComponent: AddInstitutionComponent,
    private session: SessionService,
    private toastr: ToastrService,) { }



  stepStates = {
    normal: STEP_STATE.normal,
    disabled: STEP_STATE.disabled,
    error: STEP_STATE.error,
    hidden: STEP_STATE.hidden
  };
  config: NgWizardConfig = {
    selected: 0,
    theme: THEME.arrows,
    toolbarSettings: {
      showNextButton: false,
      showPreviousButton: false,
      toolbarExtraButtons: [
        { text: 'Finish', class: 'btn btn-info visually-hidden', event: () => { alert("Finished!!!"); } }

      ],
    },
    anchorSettings: {
      anchorClickable: false,
    }
  };

  apiEventHandle(e: any): void {
    this.isFormValid = e.valid;
    this.instCode = e.instCode;
  }


  showPreviousStep(event?: Event) {
    this.ngWizardService.previous();
  }
  showNextStep(event?: Event) {
    this.selectedStep++;
    if (this.selectedStep == 1) {
      this.AddExchangeComponent.getExchangeList(this.instCode)
    }
    else if (this.selectedStep == 2) {
      this.AddBankComponent.getBankList(this.instCode)
    }
    this.ngWizardService.next();
  }
  resetWizard(event?: Event) {
    this.ngWizardService.reset();
  }
  setTheme(theme: THEME) {
    this.ngWizardService.theme(theme);
  }


  stepChanged(args: StepChangedArgs) {
  }

  isValidTypeBoolean: boolean = true;
  isValidFunctionReturnsBoolean(args: StepValidationArgs) {
    return true;
  }
  isValidFunctionReturnsObservable(args: StepValidationArgs) {
    return of(true);
  }

  onClickPrevious() {
    this.selectedStep--;
    this.showPreviousStep();
  }
  onClickNext() {
    if (this.selectedStep == 0 && !this.isFormValid) {
      this.AddInstitutionComponent.onClickAddInstitution();

    } else if (this.selectedStep == 0 && this.isFormValid) {
      this.AddInstitutionComponent.updateInstitution();
    } else if (this.selectedStep == 1) {
      this.AddExchangeComponent.setInstExchangeList();
    } else if (this.selectedStep == 2) {
      this.AddBankComponent.getValues();
      if (this.AddBankComponent.notAddedBankAcc) {
        this.AddBankComponent.changedValues();
      } else {
        this.showNextStep();
      }
    } else if (this.selectedStep == 3) {
      this.customerCreationComponent.goNext();
    }else if (this.selectedStep == 4) {
      this.CreateMasterAccountComponent.checkDone();
      if (this.CreateMasterAccountComponent.isDone) {
        this.showNextStep();
      } else {
        this.toastr.error("Please add all the required fields", "Error");
      }
    }
    else if (this.selectedStep == 5) {
      if (this.TradingLimitsInstitutionComponent.tradingLimitDone) {
        this.showNextStep();
      } else {
        this.toastr.error("Please add all the required fields", "Error");
      }
    }

  }



  done(){

    if(this.TradingLimitsInstitutionComponent.tradingLimitDone){
      this.toastr.success("Institution creating process successed", "Success");
      this.SummaryCreateInstitutionComponent.loadMethods();
      this.showNextStep();
    }else{
      this.toastr.error("Please add all the required fields", "Error");

    }



  }
  finish() {
    this.session.clear();
    window.location.reload();
  }
  click() {
    this.AddBankComponent.changedValues();
  }




  ngOnInit(): void {
    this.addInstitutionComponent.initializeInstitutionForm();
  }

}
